<!--
 * @Description: 新增/修改用户协议配置
 * @Author: 钱磊
 * @Date: 2022-08-17 11:18:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-09 09:25:12
-->

<!--  -->
<template>
  <div class="h100 mt20">
    <h5>请选择应用场景</h5>
    <el-radio-group v-model="configForm.sceneApply">
      <el-radio-button
        v-for="(item, index) of configs"
        :key="index"
        :label="item.value"
        >{{ item.sname }}</el-radio-button
      >
    </el-radio-group>
    <p class="mt20">
      已配置过的业务场景<span :style="{ color: iconColor }"
        >（说明：已经配置过的业务场景，不能配置）</span
      >
    </p>
    <el-radio-group>
      <el-radio-button
        v-for="(item, index) of sceneApplys"
        :key="index"
        :label="item.value"
        disabled
        >{{ item.sname }}</el-radio-button
      >
    </el-radio-group>
    <h5 class="mt20">
      关联协议<span v-if="choiseTable.tableData.length > 0"
        >（已选中<span :style="{ color: iconColor }">{{
          choiseTable.tableData.length
        }}</span
        >份关联协议）</span
      >
    </h5>
    <div class="w-table-content" v-show="tableShow">
      <vxe-table
        :data="choiseTable.tableData"
        :loading="choiseTable.loading"
        :border="choiseTable.border"
        :resizable="choiseTable.resizable"
        :size="choiseTable.size"
        show-overflow="tooltip"
        v-show="tableShow"
        show-header-overflow="tooltip"
      >
        <vxe-table-column
          type="seq"
          title="序号"
          align="center"
          width="70"
        ></vxe-table-column>
        <vxe-table-column
          field="sname"
          title="协议名称"
          align="center"
          show-overflow-tooltip
        ></vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          align="center"
          show-overflow-tooltip
        ></vxe-table-column>
        <vxe-table-column
          field="dealVerson"
          title="当前版本"
          align="center"
          show-overflow-tooltip
        ></vxe-table-column>
        <vxe-table-column title="展示顺序" align="center">
          <template #default="{ row, rowIndex }">
            <el-button
              type="text"
              size="mini"
              :disabled="rowIndex == 0"
              @click="sortArr(row, rowIndex, -1)"
              >升序</el-button
            >
            <el-button
              type="text"
              size="mini"
              :disabled="rowIndex == choiseTable.tableData.length - 1"
              @click="sortArr(row, rowIndex, +1)"
              >降序</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="mt20">
        <template v-if="choiseTable.tableData.length == 0">
          <el-button type="primary" icon="el-icon-plus" @click="addDeal"
            >添加协议</el-button
          >
        </template>
        <template v-else>
          <el-button type="primary" @click="saveDeal" :loading="btnLoading"
            >保存配置</el-button
          >
          <el-button @click="editDeal">修改协议</el-button>
        </template>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogObj.visible"
      :width="dialogObj.width"
      :title="dialogObj.title"
      :fullscreen="dialogObj.fullscreen"
      center
      class="add-dialog"
      :close-on-click-modal="false"
    >
      <!-- 添加协议 -->
      <template>
        <!-- 选择列表 -->
        <vxe-table
          ref="selectTable"
          :data="selectTable.tableData"
          :loading="selectTable.loading"
          :border="selectTable.border"
          :resizable="selectTable.resizable"
          :size="selectTable.size"
          :max-height="selectTable.height"
          highlight-hover-row
          @checkbox-change="selectChangeEvent"
          @checkbox-all="selectChangeAllEvent"
          auto-resize
          show-overflow="tooltip"
          show-header-overflow="tooltip"
        >
          <vxe-table-column
            type="checkbox"
            width="60"
            align="center"
          ></vxe-table-column>
          <vxe-table-column
            title="协议名称"
            width="180"
            field="sname"
            align="center"
          ></vxe-table-column>
          <vxe-table-column
            field="remark"
            title="备注"
            align="center"
          ></vxe-table-column>
          <vxe-table-column
            field="creditCode"
            title="选择协议版本"
            align="center"
          >
            <template v-slot="{ row, rowIndex }">
              <el-select
                v-model="row.dealId"
                size="mini"
                @change="changeVersion(row, rowIndex)"
              >
                <el-option
                  v-for="item of row.versions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.version"
                ></el-option>
              </el-select>
            </template>
          </vxe-table-column>
        </vxe-table>
        <div class="w-table-footer">
          <vxe-pager
            size="mini"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="totalResult"
            class="text-center"
            :page-sizes="[10, 20, 50, 100]"
            :layouts="[
              'Total',
              'Sizes',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'FullJump',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
        <div v-if="checkList.length > 0" class="checked-company">
          <p>已选择协议：</p>
          <div class="check_group">
            <span v-for="(item, index) of checkList" :key="item.id"
              >{{ item.sname
              }}<i
                class="el-icon-circle-close"
                :style="{ color: iconColor }"
                @click="deleteDeal(item, index)"
              ></i
            ></span>
          </div>
        </div>
      </template>
      <!-- footer 组件 -->
      <div slot="footer" class="pdb10 text-center">
        <el-button size="small" class="btn" @click="dialogObj.visible = false"
          >取 消
        </el-button>
        <el-button
          type="primary"
          size="small"
          class="btn btn-blue"
          @click="submitForm"
          :loading="dialogObj.btnLoading"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as API from "api/modules/rulesManagement";
export default {
  data() {
    return {
      agreementInfo: {}, //协议配置信息详情
      configs: [], //未配置业务场景
      configForm: {
        id: "",
        sceneApply: "", //应用场景
        relateDeals: "", //关联协议
      },
      sceneApplys: [], //已配置业务场景
      choiseTable: {
        //已选中协议列表对象
        tableData: [], //
        loading: false,
        border: true,
        resizable: true,
        size: "small",
        height: "100%",
      },
      tableShow: true,
      // 弹窗对象
      dialogObj: {
        visible: false,
        width: "1000px",
        title: "选择协议",
        btnLoading: false,
      },
      selectTable: {
        //弹出框选择协议的表格对象
        tableData: [],
        loading: false,
        border: true,
        resizable: true,
        size: "small",
        height: "500px",
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 当前每页条数
      totalResult: 0,
      checkList: [], //已选中协议列表
      iconColor: "red",
      btnLoading: false,
    };
  },
  components: {},
  mounted() {
    if (this.$getSessionItem("agreementInfo")) {
      this.agreementInfo = JSON.parse(this.$getSessionItem("agreementInfo"));
    }
    this.configForm.id = this.routeQuery == "add" ? "" : this.agreementInfo.id;
    this.getConfig();
  },
  methods: {
    // 协议配置-明细查询
    getConfig() {
      let param = {
        id: this.configForm.id,
      };
      API.getConfig(param).then((res) => {
        this.configs = JSON.parse(JSON.stringify(this.yycj));
        this.sceneApplys = res.data.sceneApplys;
        if (this.routeQuery == "edit") {
          this.configForm.sceneApply = res.data.sceneApply;
          this.$utils.remove(
            this.sceneApplys,
            (item) => item.value == this.configForm.sceneApply
          );
          res.data.dealList.map((item) => (item.dealVerson = item.version));
          this.choiseTable.tableData = res.data.dealList;
        }
        // this.sceneApplys=[{sname:'注册登录',value:'1001029001'},{sname:'安招采业务角色开通',value:'1001029002'}]
        this.sceneApplys.map((x) => {
          this.$utils.remove(this.configs, (item) => item.value === x.value);
        });
      });
    },
    // 展示顺序排序
    sortArr(rows, index, num) {
      this.choiseTable.tableData.splice(index, 1);
      this.choiseTable.tableData.splice(index + num, 0, rows);
    },
    // 添加协议按钮
    addDeal() {
      this.getDealPageList(1);
      this.checkList = [];
      this.$nextTick(() => {
        this.$refs.selectTable.clearCheckboxRow();
      });
      this.dialogObj.visible = true;
    },
    //修改协议按钮
    editDeal() {
      this.checkList = JSON.parse(JSON.stringify(this.choiseTable.tableData));
      this.getDealPageList(1);

      this.dialogObj.visible = true;
    },
    //获取协议分页列表
    getDealPageList(page) {
      if (page) {
        this.currentPage = page;
      }
      let params = {
        current: this.currentPage,
        size: this.pageSize,
      };
      API.getDealPageList(params).then((res) => {
        res.data.records.map((x) => {
          x.dealId = x.versions[0].id;
          x.dealVerson = x.versions[0].version;
          if (this.routeQuery == "edit") {
            //当是编辑模式时给list加上dealID，versions....等参数
            this.checkList.map((y) => {
              if (x.id == y.id) {
                y.versions = x.versions;
                x.versions.forEach((item) => {
                  if (item.version == y.dealVerson) {
                    y.dealId = item.id;
                  }
                });
              }
            });
          }
        });
        if (this.checkList.length > 0) {
          res.data.records.map((x) => {
            this.checkList.map((y) => {
              if (x.id == y.id) {
                x.dealId = y.dealId;
                x.dealVerson = y.dealVerson;
              }
            });
          });
        }

        this.selectTable.tableData = res.data.records;
        this.totalResult = parseInt(res.data.total);
      });
    },
    //当多选框发生改变时
    selectChangeEvent(val) {
      console.log(val);
      if (val.checked == true) {
        this.checkList.push(val.row);
      } else {
        this.$utils.remove(this.checkList, (item) => item.id == val.row.id);
      }
    },
    selectChangeAllEvent(val) {
      console.log(val);
      if (val.checked == true) {
        val.records.map((item) => {
          console.log(this.checkList.includes(item))
          if(!this.checkList.includes(item)){
            this.checkList.push(item)
          }
        });
      } else {
        this.selectTable.tableData.map((item) => {
          this.$utils.remove(this.checkList, (item1) => item1.id == item.id);
        });
      }
      console.log(this.checkList)
    },
    //保存协议配置信息
    saveDeal() {
      this.btnLoading = true;
      if (this.configForm.sceneApply == "") {
        this.$message.warning("请选择应用场景！");
        setTimeout(() => {
          this.btnLoading = false;
        }, 1000);
      } else {
        let checkId = this.choiseTable.tableData.map((x) => x.dealId);
        let params = Object.assign({}, this.configForm);
        params.relateDeals = checkId.join(",");
        API.saveConfig(params)
          .then((res) => {
            if (res.operationCode == 1) {
              this.$router.push({
                path: "/agreement-setting",
              });
              this.$emit("close");
            } else {
              setTimeout(() => {
                this.btnLoading = false;
              }, 1000);
            }
          })
          .catch((err) => {
            setTimeout(() => {
              this.btnLoading = false;
            }, 1000);
          });
      }
    },
    // 选择协议版本时
    changeVersion(rows, index) {
      this.checkList.map((item) => {
        if (item.id == rows.id) {
          item.dealId = rows.dealId;
        }
      });
    },
    //选择单位时的删除图标
    deleteDeal(item, index) {
      let _item = this.selectTable.tableData.find((x) => x.id == item.id);
      if (_item != undefined) {
        this.$refs.selectTable.setCheckboxRow(_item, false);
      }
      this.checkList.splice(index, 1);
    },
    //弹出框的确认按钮
    submitForm() {
      if (this.checkList.length <= 10) {
        console.log(this.checkList);
        this.checkList.map((x) => {
          let version = x.versions.find((y) => y.id == x.dealId);
          x.dealVerson = version.version;
        });
        this.choiseTable.tableData = JSON.parse(JSON.stringify(this.checkList));
        setTimeout(() => {
          this.dialogObj.visible = false;
        }, 50);
      } else {
        this.$message.warning("每次最多选择十个协议！");
      }
    },
    // 切换分页
    handlePageChange({ currentPage, pageSize }) {
      this.currentPage = currentPage;
      this.pageSize = pageSize;
      this.getDealPageList();
      this.clearCheckbox().then(() => {
        setTimeout(() => {
          this.checkList.map((item) => {
            let _item = this.selectTable.tableData.find((x) => x.id == item.id);
            if (_item != undefined) {
              this.$refs.selectTable.setCheckboxRow(_item, true);
            }
          });
        }, 300);
      });
    },
    clearCheckbox() {
      return new Promise((resolve, reject) => {
        this.$refs.selectTable.clearCheckboxRow();
        resolve();
      });
    },
  },
  computed: {
    routeQuery() {
      return this.$route.query.type;
    },
    ...mapState("dict", {
      yycj: (state) => state.yycj,
    }),
  },
  watch: {
    checkList: {
      handler: function (newVal) {
        setTimeout(() => {
          newVal.map((item) => {
            let _item = this.selectTable.tableData.find((x) => x.id == item.id);
            if (_item != undefined) {
              this.$refs.selectTable.setCheckboxRow(_item, true);
            }
          });
        }, 500);
      },
      deep: "true",
    },
  },
};
</script>
<style scoped lang='less'>
h5,
h6,
p {
  padding-bottom: 10px;
  border-bottom: 1px solid #333;
}
p {
  font-size: 12px;
}
/deep/ .el-radio-button {
  width: 200px !important;
  margin-left: 20px;
}
/deep/ .el-radio-group {
  display: flex;
  flex-wrap: wrap;
}
/deep/ .el-radio-button__inner {
  border: 1px solid #dcdfe6 !important;
  margin: 10px !important;

  width: 100%;
  display: inline-block;
  border-radius: 4px !important;
}
.check_group {
  width: 100%;
  padding: 20px;
  background-color: #f2f2f2;
  span {
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
    padding: 10px 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    .el-icon-circle-close {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
.w-table-content {
  width: 90%;
  margin: 20px 0 0 20px;
}
</style>